/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

/**
 * Created by XPL on 2018/3/20.
 */
import cookies from 'vue-cookie'
const testing = process.env.NODE_ENV === 'production_testing' || process.env.NODE_ENV == 'development'
const uat = process.env.NODE_ENV == 'uat'
const mooc = process.env.NODE_ENV == 'mooc'
console.log(testing, 'testing-----------')
console.log(uat, 'uat-----------')
console.log(mooc, 'mooc-----------')
console.log(process.env.NODE_ENV, 'process.env.NODE_ENV-----------')
export let commonParams = {}
export let options = {
  param: 'jsonpCallback'
}

export let removePending = (config, obj) => {
  for (let p in obj) {
    if (obj[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      obj[p].f(); //  执行取消操作
      obj.splice(p, 1); //  把这条记录从数组中移除
    }
  }
}

export const ERR_OK = 200
export const ERR_LOGINAGAIN = 401
export const ERR_OK_STR = 'ok'
export const REQUEST_PREFIX = testing ? 'https://server.eeidm.com:8085/api' : 'https://server.eeidm.com:8085/api'
export const EEIDM_URl = testing ? 'https://tc.devplatform.eec2m.com/api' : uat ? 'https://tc.uatplatform.eec2m.com/api' : mooc ? 'https://tc.mooc.inzaowu.com/api' : 'https://order.inzaowu.com/api' // https://ordercloud.eeidm.com
export const EEIDM_URl_CRM = testing ? 'https://crm.devplatform.eec2m.com/api' : uat ? 'https://crm.uatplatform.eec2m.com/api' : mooc ? 'https://crm.mooc.inzaowu.com/api' : 'https://order.inzaowu.com'
export const EEIDM_URl_TC = testing ? "https://tc.devplatform.eec2m.com/api" : uat ? 'https://tc.uatplatform.eec2m.com/api' : mooc ? 'https://tc.mooc.inzaowu.com/api' : "https://tc.inzaowu.com/api"
export const EEIDM_URl_ORDER = testing ? "https://order.devplatform.eec2m.com/api" : uat ? 'https://order.uatplatform.eec2m.com/api' : mooc ? 'https://order.mooc.inzaowu.com/api' : "https://order.inzaowu.com/api"

// 本地环境开发 模拟登录 -- 通过接口文档拿到用户信息跟token 在手动存到cookies里面
// const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0ZW5hbnRJZCI6IjY2MDQ5OTQzNDE5ODU0ODQ4MCIsImV4cCI6MTczOTI2MTQ0NywidXNlcm5hbWUiOiJkbWVBZG1pbiJ9.uFyHzcHOoiMXS2p69ueE4VusMtTTAiUr0IQEucrfw4A'
// const userInfo = {
//   address: '深圳福田梅林',
//   consignee: '泽泽222',
//   createTime: 1677289185000,
//   customerArea: 'A001',
//   delFlag: 0,
//   email: '362@qq.com',
//   id: '470887736585236480',
//   managerFlag: true,
//   managerId: '472364112752414720',
//   password: '942300070212356d29b6b0b3929e6f71',
//   phone: '19926442511',
//   qq: '124345679101',
//   realname: '泽泽',
//   sex: 2,
//   status: 1,
//   userIdentity: 1,
//   username: 'dmeAdmin',
//   wechat: '00010',
//   workNo: 'EE002556'
// }
// cookies.set('devEeidmUserInfo', JSON.stringify(userInfo))
// cookies.set('devEeidmAuthorToken', token)

let info = testing || uat ? cookies.get('devEeidmUserInfo') : cookies.get('EeidmUserInfo')
let infoType = info ? JSON.parse(info) : info
export const EEIDM_URl_MANAGER = infoType ? infoType.managerFlag == true ? '/manage' : '' : ''

export let thirdParty = {
  wechat: {
    url: 'https://open.weixin.qq.com/connect/qrconnect',
    webUrl: 'https://open.weixin.qq.com/connect/oauth2/authorize',
    reUrl: 'https://api.weixin.qq.com/sns/oauth2/refresh_token',
    webReUrl: 'https://api.weixin.qq.com/sns/oauth2/refresh_token',
    appId: 'wxb7044f7a7d3f8a78', // wxef3355d78cfc7a3d
    devAppId: 'wxb7044f7a7d3f8a78', // "wxa6b9e9095db32224"
    devUri: 'http://open.dev.tech2real.com/m-web/user/mobilebind',
    uri: 'http://open.tech2real.com/m-web/user/mobilebind',
    devBindUri: 'http://open.dev.tech2real.com/m-web/me/setting/safety/bindMobile',
    bindUri: 'http://open.tech2real.com/m-web/me/setting/safety/bindMobile'
  },
  qq: {
    url: 'https://graph.qq.com/oauth2.0/authorize',
    webUrl: 'https://graph.qq.com/moc2/authorize',
    reUrl: 'https://api.weixin.qq.com/sns/oauth2/refresh_token',
    webReUrl: 'https://api.weixin.qq.com/sns/oauth2/refresh_token',
    devAppId: '101367357',
    appId: '101367357',
    devUri: 'http://open.dev.tech2real.com/m-web/user/mobilebind',
    uri: 'http://open.tech2real.com/m-web/user/mobilebind',
    devBindUri: 'http://open.dev.tech2real.com/m-web/me/setting/safety/bindMobile',
    bindUri: 'http://open.tech2real.com/m-web/me/setting/safety/bindMobile'
  },
  weibo: {
    url: 'https://api.weibo.com/oauth2/authorize',
    webUrl: 'https://open.weibo.cn/oauth2/authorize',
    reUrl: 'https://api.weixin.qq.com/sns/oauth2/refresh_token',
    webReUrl: 'https://api.weixin.qq.com/sns/oauth2/refresh_token',
    devAppId: '182034898',
    appId: '182034898',
    devUri: 'http://weibo.tech2real.com/m-web/user/mobilebind',
    uri: 'http://weibo.tech2real.com/m-web/user/mobilebind',
    devBindUri: 'http://weibo.tech2real.com/m-web/me/setting/safety/bindMobile',
    bindUri: 'http://open.tech2real.com/m-web/me/setting/safety/bindMobile'
  }
}
export let share = {
  appUrl: 'https://open.dev.tech2real.com/m-web/',
  appDevUrl: 'https://open.dev.tech2real.com/m-web/',
  title: '硬见|智慧连接硬件创新', // 分享标题
  desc: '硬见|智慧连接硬件创新', // 分享理由
  summary: '硬见|智慧连接硬件创新', // 分享描述
  cover: 'https://dn-funnymeet.qbox.me/FucweAr6nX1IOpWpBz4nJMbugmHE?e=1803029570&token=u0R-dgswbXXA1PMGqJlkEIo8pc_iWtp5OuM67d94:XUF4SCL1atopTWdsDM639V8Kv04=', // 分享封面
  source: '硬见' // 分享来源
}
export let storageVTime = {
  orderInfo: 1 * 60 * 60 * 1000
}




// WEBPACK FOOTER //
// ./src/api/config.js